module.exports = __webpack_public_path__ + "img/img49.159b5aff.png";